<template>
  <div class="loader_large"></div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.loader_large {
  position: fixed;
  max-width: 600px;
  margin: auto;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: opacity 0.4s;
  &.hide {
    opacity: 0;
    pointer-events: none;
  }
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: $hero-height;
    background-repeat: no-repeat;
    background-image:
      linear-gradient(darken($skeleton-color, 5%) 40px, transparent 0),
      linear-gradient($skeleton-color 100%, transparent 0);
    background-size:
      60% 40px,
      100% 100%;

    background-position:
      $padding calc(#{$hero-height - $hero-heading-bottom} - 40px),
      0 0;
  }
  &::after {
    content: '';
    display: block;
    height: 100%;
    margin: auto;
    background-repeat: no-repeat;
    background-image:
      linear-gradient($skeleton-color 40px, transparent 0),
      linear-gradient($skeleton-color 20px, transparent 0),
      linear-gradient($skeleton-color 20px, transparent 0),
      linear-gradient($skeleton-color 20px, transparent 0),
      linear-gradient($skeleton-color $image-caption-height, transparent 0),
      linear-gradient($skeleton-color 20px, transparent 0),
      linear-gradient($skeleton-color 20px, transparent 0),
      linear-gradient($skeleton-color 20px, transparent 0),
      linear-gradient($skeleton-color 20px, transparent 0),
      linear-gradient(white 100%, transparent 0);
      background-size:
        80% 40px,
        75% 20px,
        80% 20px,
        70% 20px,
        calc(100% - #{$padding * 2}) $image-caption-height,
        90% 20px,
        80% 20px,
        85% 20px,
        35% 20px,
        100% 100%;

      background-position:
        $padding $padding * 2,
        $padding 90px,
        $padding 120px,
        $padding 150px,
        $padding 190px,
        $padding 370px,
        $padding 400px,
        $padding 430px,
        $padding 460px,
        0 0;
  }
}
</style>
